import React, { useState, useRef, useEffect, Fragment } from "react";
import "./../components/Report.scss";
import { _hasPermission } from "../../../../../../shared/helpers/access";
import { _axiosCall } from "../../../../../../shared/helpers/apicalls";
import moment from "moment";
import CircularProgress from "./../../components/CircularProgress";
import CustomBarChart from "./../../components/CustomBarChart";
import CustomLineChart from "./../../components/CustomLineChart";
import CustomSwitch from "./../../components/CustomSwitch";
import CustomTable from "./../../components/CustomTable";
import Indicator from "./../../components/Indicator";
import Divider from "./../../components/Divider";
import HorizontalBarChart from "./../../components/HorizontalBarChart";
import Footer from "./../components/Footer";

import {
  _capitalizeText,
  _formatNumber,
  _formatPrice,
  _formatCurrency,
  _nameToUrl,
  _shouldShow,
  _getBuildingURL,
  buildingFL,
  _replaceAbbreviations,
  _formatBed,
  propertyFL,
  SalesProgress,
  _isEqual,
  _tranformTagsQuery,
  syncURLFilters,
  syncURLSearch,
  setURLFromState,
  setLocalStorage,
  getLocalStorage,
  deleteLocalStorage,
  syncStageFilters,
  mpndCohortQuery,
  syncGenericFilter,
  urlSlugBuilding,
  _isNewUser,
  _isEnterpriseUser,
  _objectEqual,
  getCohortQuery,
  _activityFQ,
  _isHouse,
  _formatBigPrice,
  houseBuildingCohortQuery,
  _activityFL,
} from "../../../../../../shared/helpers/utils";
import {
  borderRadius,
  fontSize,
  fontWeight,
  height,
  width,
} from "@material-ui/system";
// import Chart from "./Chart";
import { formatDateRange, calculatePercentageChange, previousYearPeriod, generatePeriodNames, percentageChange, prepareResForAI, validateNestedData, filterAIData, getCurrentPeriod, getPriorPeriod,  getRangeEnd, getRangeStart} from "../../../exportreport/utils"
import CustomSkeleton from "../components/Skeleton";
const apiURL = process.env.API_ROOT;


let statTypes = [
  
  {
    key: "luxury_sales",
    title: "$4M+ Properties",
    name: "Luxury Market Report",
    checkedColor: "#780F9E",
    activitesQuery:
      '(price:[4000000 TO *]) AND event_tags:(condo* co?op* coop* condo*p single?family property-source_rls)',
    default: true,
  },
  {
    key: "luxury_sales_four_to_ten_million",
    title: "Luxury Market - $4M to $10M Properties",
    name: "$4M - $10M",
    checkedColor: "#780F9E",
    activitesQuery:
      '(price:[4000000 TO 10000000]) AND event_tags:(condo* co?op* coop* condo*p single?family property-source_rls)',
    default: true,
  },
  {
    key: "luxury_sales_ten_plus_million",
    title: "Luxury Market - $10M+ Properties",
    name: "$10M+",
    checkedColor: "#780F9E",
    activitesQuery:
      '(price:[10000001 TO *]) AND event_tags:(condo* co?op* coop* condo*p single?family property-source_rls)',
    default: true,
  },
 
];



const statFacet = {
   "med_price":"percentile(price, 50)",
   "by_borough" : {
     "type" : "terms",
     "field" : "borough",
     "facet" : {
        "med_price":"percentile(price, 50)"
     }
   },
   "ppsf":{
      "type":"query",
      "q":"sq_ft:[300 TO 20000]",
      "facet":{
         "med":"percentile(div(price, sq_ft), 50)"
      }
   },
   "dom":{
      "type":"query",
      "q":"days_on_market:[3 TO 720]",
      "facet":{
         "med":"percentile(days_on_market, 50)"
      }
   },
   "newdev":{
       "type":"query",
       "q":`(event_tags:(event-stage_sponsor) AND -address_2_normalized:"")`
    },
   "condo":{
      "type":"query",
      "q":`(event_tags:(condo* !condo*p) AND -event_tags:(event-stage_sponsor) AND -address_2_normalized:"")`
   },
   "coop":{
      "type":"query",
      "q":`(event_tags:(co?op* coop* condo*p) AND -event_tags:(event-stage_sponsor) AND -address_2_normalized:"")`
   },
   "townhouse":{
      "type":"query",
      "q":`(event_tags:(single?family property-source_rls) AND address_2_normalized:"")`
   }
}




const BlendedLayout = (props) => {
  const {
    fetchInProgress,
    setFetchInProgress,
    user,
    reportLoaded,
    setReportLoaded,
    reportData,
    setReportData,
    searchTags,
    summarizeGeographies,
    customDate,
    submit,
    setSubmit,
    color,
    setAiResponse,
    AiResponse,
    setFetchAi,
    fetchAi,
    setAIInProgress
  } = props;
  const { dateOptions, theme, style } = customDate;
  
 const currentPeriod = getCurrentPeriod(dateOptions)
 const priorPeriod = getPriorPeriod(dateOptions)
 
 const priorYearPeriod = priorPeriod;
 const rangeEnd = getRangeEnd(dateOptions);
 const rangeStart = getRangeStart;
 const gap = dateOptions.gap;
 const currentPeriodName = generatePeriodNames(dateOptions).currentPeriod;
 const priorYearPeriodName = generatePeriodNames(dateOptions).priorYearPeriod;
  useEffect(() => {
    if (!reportData && !fetchInProgress && submit) {
      loadData();
      setSubmit(false)
    }
  }, [submit]);
  useEffect(() => {
    console.log(reportData, fetchAi)
      const fetchAIData = async () => {
       setFetchAi &&  setFetchAi(false);
       setAIInProgress(true);
       let  aiData = prepareResForAI(JSON.parse(JSON.stringify(reportData.facets)));
       const aiResponse = await handleAIGenerate(aiData);
        setAiResponse &&  setAiResponse(aiResponse);
        setAIInProgress(false);
      };
    
      if ( reportData && fetchAi) {
        fetchAIData();
        
      }
    }, [reportData, fetchAi])
  const dataFacet = {
  contract_signed: {
    type: "query",
    q: "topic:listings AND event_tags:contract-signed AND -event_tags:rent AND -event_tags:*commercial*",
    facet: {
    current_period: {
      type: "query",
      q: `time:${currentPeriod}`,
      facet: statFacet,
    },
    prior_year_period: {
      type: "query",
      q: `time:${priorYearPeriod}`,
      facet: statFacet,
    },
    chart: {
      range: {
      field: "time",
      start: rangeStart,
      end: rangeEnd,
      gap: gap,
      facet: {
        dom: {
        type: "query",
        q: "days_on_market:[3 TO 720]",
        facet: {
          avg: "avg(days_on_market)",
          med: "percentile(days_on_market, 50)",
        },
        },
      },
      },
    },
    },
  },
  recorded_sold: {
    type: "query",
    q: "topic:transactions AND event_tags:recorded-sale AND -event_tags:*commercial* AND  -event_tags:property-type_parking-space AND -event_tags:property-type_storage-room AND -event_tags:parcels_bulk-sale",
    facet: {
    current_period: {
      type: "query",
      q: `time:${currentPeriod}`,
      facet: statFacet,
    },
    prior_year_period: {
      type: "query",
      q: `time:${priorYearPeriod}`,
      facet: statFacet,
    },
    chart: {
      range: {
      field: "time",
      start: rangeStart,
      end: rangeEnd,
      gap: gap,
      facet: {
        med_price: "avg(price)",
        med_price: "percentile(price, 50)",
        sum_price: "sum(price)",
        ppsf: {
        type: "query",
        q: "sq_ft:[300 TO 20000]",
        facet: {
          avg: "avg(div(price, sq_ft))",
          med: "percentile(div(price, sq_ft), 50)",
        },
        },
      },
      },
    },
    },
  },
  }

  const loadData = async () => {
    let q = "*:*";
    let locQuery = _tranformTagsQuery(searchTags);

    if (locQuery) {
      q = locQuery;
    }

    const defaultQ = getCohortQuery(user, true);
    const fq = [
      ..._activityFQ.slice(),
      ...[
        `{!join from=alternate_keys fromIndex=we3-buildings to=building}${defaultQ}`,
      ],
    ];
    setFetchInProgress(true);
    let facet = {}
    statTypes.map(item => {
      facet[item.key] = {
        "type" : "query",
        "q" : item.activitesQuery,
        "facet" : dataFacet
      }
      
    })
    let axiosData = {
      url: apiURL + "/query/we3-activities-3",
      method: "post",
      query: {
        q: q,
        fq: fq,
        wt: "json",
        rows: 0,
        "json.facet": facet
      },
    };

    let res = await _axiosCall(axiosData)
      .then(async (res) => {
        let aiData;
        if (res && res.facets) {
          // aiData = prepareResForAI(JSON.parse(JSON.stringify(res.facets)));
          // const aiResponse = await handleAIGenerate(aiData);
          // res["aiResponse"] = aiResponse;
          setFetchInProgress(false);
          setReportLoaded(true);
          setSubmit(false);
          setReportData(res);
          setFetchAi &&  setFetchAi(true);
        }
        return res;
      })
      .catch((error) => {
        console.log("error: " + error);
      });
  };
  const handleAIGenerate = async (data) => {
    const prompt = `Given the following data give me an analysis that speaks to current period trends vs prior year periods for the luxury market, the chart contains more history.  The analysis should look at root nodes and separately analayze  contracts_signed and recorded_sold.  The analysis should be easy to understand for consumer audiences.  For contracts_signed focus only on the count of contracts and days on market (dom), for recorded_sold ignore count and focus on prices.  The analysis should be  concise, 2 to 3 sentences.  Just text.  Abbreviate long currency so it's $1.5M, round if less than $1M.  If less than $1M use K.  Number should be in format ###,###,###  The results should be in valid raw JSON format, no formatting.  { "luxury_sales" : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, luxury_sales_four_to_ten_million : { contracts_signed: "analysis in text", recorded_sales: "analysis in text"}, luxury_sales_ten_plus_million: { contracts_signed: "analysis in text", recorded_sales: "analysis in text"} }
    
    The report contains the following key stats:${JSON.stringify(filterAIData(data))}
    
    The report's geography focuses on ${summarizeGeographies(searchTags)}
    
    Current Period: ${currentPeriodName}
    Prior Year Period: ${priorYearPeriodName}`;

    const queryData = {
      messages: [
        {
          role: "system",
          content: `You are a NYC real estate expert that provides insightly data-driven analysis that are easy to understand.  You speak in a professional yet friendly manner.  Think TV or news analysts.`,
        },
        { role: "user", content: prompt },
      ],
      model: "gpt-4o",
      response_format: { type: "json_object" },
    };

    const axiosData = {
      url: apiURL + "/ai/chat",
      method: "post",
      query: queryData,
    };
    let aiResponse = {};
    try {
      const res = await _axiosCall(axiosData);
      console.log(res);

      if (
        res &&
        res.choices &&
        res.choices[0] &&
        res.choices[0].message &&
        res.choices[0].message.content
      ) {
        const result = res.choices[0].message.content;
        
        try {
          aiResponse = JSON.parse(result);
          console.log(aiResponse);
        } catch (e) {}
      }
    } catch (error) {
      console.log("Error generating summary:", error);
    }
    return aiResponse;
  };
  
  const percentageChange = (
    newValue,
    oldValue
  ) => {
    if(oldValue===0) return "--"
    const percentageChange = ((newValue - oldValue) / oldValue) * 100;
    const roundedChange = Math.round(percentageChange * 10) / 10;
    
    return roundedChange
  }
  
  const PropertyTypePage = (props) => {
    const { name, title, type, selectedStyle } = props;
    const hasLocation = searchTags && searchTags.length>0
    return (
      <div className="report-container page-section">
        <section className="report-section">
          <h3 className="header-text heading-location editable">{searchTags && searchTags.length>0 ? _capitalizeText(summarizeGeographies(searchTags)) : "New York City"}</h3>
          <div className="header-subtext__heading editable">{type.name}</div>
          <div className="subtext-grid">
            <div className="header-inner-subtext__heading editable">
              {type.title}
            </div>
            <div>
              <div>Date Range</div>
              <div className="editable">{priorYearPeriodName} vs. {currentPeriodName}</div>
            </div>
          </div>
      
          <div className="semi-progress-container">
            <div className="inner_heading_container">
              <div>Contracts</div>
              {/* component for semi circle */}
              <CircularProgress value={(validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.count`
                ) &&
                validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.prior_year_period.count`
                )
                  ? percentageChange(
                      reportData.facets[type.key].contract_signed.current_period
                        .count,
                      reportData.facets[type.key].contract_signed.prior_year_period
                        .count
                    )
                  : "0")} />
            </div>
            <CustomSwitch
              rows={[
                {
                  firstValue: "Volume",
                  middleValue: "",
                  lastValue: "Days",
                  header: true,
                },
                {
                  firstValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.current_period.count`)  ? _formatNumber(reportData.facets[type.key].contract_signed.current_period.count) : "--",
                  middleValue: currentPeriodName,
                  lastValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.current_period.dom.med`)  ? _formatNumber(reportData.facets[type.key].contract_signed.current_period.dom.med) + " Days" : "--",
                },
                {
                  firstValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.prior_year_period.count`)  ? _formatNumber(reportData.facets[type.key].contract_signed.prior_year_period.count) : "--",
                  middleValue: priorYearPeriodName,
                  lastValue: validateNestedData(reportData, `facets.${type.key}.contract_signed.prior_year_period.dom.med`)  ? _formatNumber(reportData.facets[type.key].contract_signed.prior_year_period.dom.med) + " Days" : "--",
                },
              ]}
              hightlightedElement={1}
            />
            <div className="inner_heading_container">
              <div>Days on Market</div>
              <div>
                <CircularProgress value={(validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.dom.med`
                ) &&
                validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.prior_year_period.dom.med`
                )
                  ? percentageChange(
                      reportData.facets[type.key].contract_signed.current_period
                        .dom.med,
                      reportData.facets[type.key].contract_signed.prior_year_period
                        .dom.med
                    )
                  : "0")} reverse={true} />
              </div>
            </div>
          </div>
          <div className="report-layout-table-container">
            <CustomTable
              headers={["TYPE", currentPeriodName, priorYearPeriodName, "% CHANGE"]}
              rows={[
                ["NEW DEV", validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.newdev.count`
                )
                  ? _formatNumber(
                      reportData.facets[type.key].contract_signed.current_period
                        .newdev.count
                    )
                  : "--", validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.newdev.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.prior_year_period
                          .newdev.count
                      )
                    : "--", validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.current_period.newdev.count`
                    ) &&
                    validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.prior_year_period.newdev.count`
                    )
                      ? percentageChange(
                          reportData.facets[type.key].contract_signed.current_period
                            .newdev.count,
                          reportData.facets[type.key].contract_signed.prior_year_period
                            .newdev.count
                        ) + "%"
                      : "--"],
                ["RESALE CONDO", validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.condo.count`
                )
                  ? _formatNumber(
                      reportData.facets[type.key].contract_signed.current_period
                        .condo.count
                    )
                  : "--", validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.condo.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.prior_year_period
                          .condo.count
                      )
                    : "--", validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.current_period.condo.count`
                    ) &&
                    validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.prior_year_period.condo.count`
                    )
                      ? percentageChange(
                          reportData.facets[type.key].contract_signed.current_period
                            .condo.count,
                          reportData.facets[type.key].contract_signed.prior_year_period
                            .condo.count
                        ) + "%"
                      : "--"],
                ["RESALE CO-OP", validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.coop.count`
                )
                  ? _formatNumber(
                      reportData.facets[type.key].contract_signed.current_period
                        .coop.count
                    )
                  : "--", validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.coop.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.prior_year_period
                          .coop.count
                      )
                    : "--", validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.current_period.coop.count`
                    ) &&
                    validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.prior_year_period.coop.count`
                    )
                      ? percentageChange(
                          reportData.facets[type.key].contract_signed.current_period
                            .coop.count,
                          reportData.facets[type.key].contract_signed.prior_year_period
                            .coop.count
                        ) + "%"
                      : "--"],
                ["TOWNHOUSE", validateNestedData(
                  reportData,
                  `facets.${type.key}.contract_signed.current_period.townhouse.count`
                )
                  ? _formatNumber(
                      reportData.facets[type.key].contract_signed.current_period
                        .townhouse.count
                    )
                  : "--", validateNestedData(
                    reportData,
                    `facets.${type.key}.contract_signed.current_period.townhouse.count`
                  )
                    ? _formatNumber(
                        reportData.facets[type.key].contract_signed.prior_year_period
                          .townhouse.count
                      )
                    : "--", validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.current_period.townhouse.count`
                    ) &&
                    validateNestedData(
                      reportData,
                      `facets.${type.key}.contract_signed.prior_year_period.townhouse.count`
                    )
                      ? percentageChange(
                          reportData.facets[type.key].contract_signed.current_period
                            .townhouse.count,
                          reportData.facets[type.key].contract_signed.prior_year_period
                            .townhouse.count
                        ) + "%"
                      : "--"]
              ]}
              theme={theme}
              color={color}
            />
            <div className="table-side-container">
              <p className="editable">
                {AiResponse && AiResponse[type.key] && AiResponse[type.key].contracts_signed? AiResponse[type.key].contracts_signed:<CustomSkeleton count={4}/>}
              </p>
      
              
            </div>
          </div>
        </section>
        <Divider theme={theme} />
        <section className="report-section">
          <div className="custom-charts">
            <div className="indicator-container">
              <div className="heading">CLOSINGS</div>
              <Indicator
                price={validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.med_price`)  ? _formatPrice(reportData.facets[type.key].recorded_sold.current_period.med_price) : "--"}
                percentage={validateNestedData(
                    reportData,
                    `facets.${type.key}.recorded_sold.current_period.med_price`
                  )
                    ? percentageChange(
                        reportData.facets[type.key].recorded_sold.current_period
                          .med_price,
                        reportData.facets[type.key].recorded_sold.prior_year_period
                          .med_price
                      )
                    : "--"}
                reverse={true}
                name="Med Price"
              />
              <Indicator
                price={validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.ppsf.med`)  ? _formatPrice(reportData.facets[type.key].recorded_sold.current_period.ppsf.med) : "--"}
                percentage={validateNestedData(
                    reportData,
                    `facets.${type.key}.recorded_sold.current_period.ppsf.med`
                  )
                    ? percentageChange(
                        reportData.facets[type.key].recorded_sold.current_period
                          .ppsf.med,
                        reportData.facets[type.key].recorded_sold.prior_year_period
                          .ppsf.med
                      )
                    : "--"}
                reverse={true}
                name="Price S/F"
              />
            </div>
            <div className="chart_wrapper">
              <div className="subtext editable">
                  {AiResponse && AiResponse[type.key] && AiResponse[type.key].recorded_sales? AiResponse[type.key].recorded_sales:<CustomSkeleton count={4}/>}
              </div>
              <div className="chart_inner">
                <div className={`Chart-1 ${hasLocation ? "Has-Loc" : ""}`}>
                  <div className="heading">MEDIAN PRICE / SF</div>
                  <CustomLineChart
                    theme={theme}
                    data={reportData.facets[type.key].recorded_sold.chart.buckets.slice(reportData.facets[type.key].recorded_sold.chart.buckets.length - 12,reportData.facets[type.key].recorded_sold.chart.buckets.length).map(item => ({year : formatDateRange(null, null, item.val), price: item.ppsf && item.ppsf.med ? Math.round(item.ppsf.med) : 0}))}
                 isWeekly={dateOptions.gap}
                 />
                </div>
                {(!hasLocation) ?
                <div className="Chart-2">
                  <div className="heading">MEDIAN PRICE</div>
                  <CustomBarChart
                    theme={theme}
                    data={[
                      { name: "MN", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "manhattan")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "manhattan")[0].med_price) : 0 },
                      { name: "BK", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "brooklyn")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "brooklyn")[0].med_price) : "--" },
                      { name: "QN", value: validateNestedData(reportData, `facets.${type.key}.recorded_sold.current_period.by_borough.buckets`) && reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "queens")[0]  ? (reportData.facets[type.key].recorded_sold.current_period.by_borough.buckets.filter(item => item.val == "queens")[0].med_price) : 0 },
                    ]}
                    isWeekly={dateOptions.gap}
                  />
                </div>:null}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    )
  }
  if (!reportData) return null;
  return (
    <>
    {statTypes.map(type => {
      
      return <PropertyTypePage type={type}/>
      
    })}
    </>
  )
    
  
//   return (
//     <>
//       <div className="report-container page-section">
//         <section className="report-section">
//           <h3 className="header-text">New York City</h3>
//           <div className="header-subtext__heading">Residential Sales</div>
//           <div className="subtext-grid">
//             <div className="header-inner-subtext__heading">
//               CONDO, CO-OP, SINGLE-FAMILY & MULTI-FAMILY
//             </div>
//             <div>
//               <div>Date Range</div>
//               <div>YTD 2023 vs YTD 2024</div>
//             </div>
//           </div>
// 
//           <div className="semi-progress-container">
//             <div className="inner_heading_container">
//               <div>Contracts</div>
//               {/* component for semi circle */}
//               <CircularProgress value={"30%"} isPositive={true} />
//             </div>
//             <CustomSwitch
//               rows={[
//                 {
//                   firstValue: "Volume",
//                   middleValue: "",
//                   lastValue: "Days",
//                   header: true,
//                 },
//                 {
//                   firstValue: "10,895",
//                   middleValue: "YTD 2024",
//                   lastValue: "77 Days",
//                 },
//                 {
//                   firstValue: "12,183",
//                   middleValue: "YTD 2023",
//                   lastValue: "83 Days",
//                 },
//               ]}
//               hightlightedElement={1}
//             />
//             <div className="inner_heading_container">
//               <div>Days on Market</div>
//               <div>
//                 <CircularProgress value={"37%"} isPositive={false} />
//               </div>
//             </div>
//           </div>
//           <div className="report-layout-table-container">
//             <CustomTable
//               headers={["PRICE RANGE", "YTD 2024", "YTD 2023", "% CHANGE"]}
//               rows={[
//                 ["UNDER $1M", "4,995", "6,040", "-17.3%"],
//                 ["$1M - $2M", "3,104", "3,312", "-6.3%"],
//                 ["$2M - $4M", "1,822", "1,780", "+2.4%"],
//                 ["$4M - $10M", "796", "865", "-8%"],
//                 ["OVER $10M", "178", "186", "-4.3%"],
//               ]}
//               theme={theme}
//               color={color}
//             />
//             <div className="table-side-container">
//               <p>
//                 Contract volume in 2024 retreated compared to 2023, reflecting a
//                 cooling post-COVID recovery market and the delayed effects of
//                 high mortgage rates.
//               </p>
// 
//               <p>
//                 Homes spent an average of six fewer days on the market in 2024,
//                 indicating that buyers are still quick to seize opportunities.
//               </p>
//             </div>
//           </div>
//         </section>
//         <Divider theme={theme} />
//         <section className="report-section">
//           <div className="custom-charts">
//             <div className="indicator-container">
//               <h3 className="heading">CLOSINGS</h3>
//               <Indicator
//                 price="$863K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Med Price"
//               />
//               <Indicator
//                 price="$663K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Price S/F"
//               />
//             </div>
//             <div className="chart_wrapper">
//               <div className="subtext">
//                 NYC has seen a steady rise in median prices and price per square
//                 foot overall, with Manhattan's sold prices nearly double those
//                 of Brooklyn and Queens
//               </div>
//               <div className="chart_inner">
//                 <div className="Chart-1">
//                   <div className="heading">MEDIAN PRICE / SF</div>
//                   <CustomLineChart
//                     theme={theme}
//                     data={[
//                       { year: "2015", price: 417 },
//                       { year: "2016", price: 450 },
//                       { year: "2017", price: 480 },
//                       { year: "2018", price: 500 },
//                       { year: "2019", price: 520 },
//                       { year: "2020", price: 540 },
//                       { year: "2021", price: 600 },
//                       { year: "2022", price: 610 },
//                       { year: "2023", price: 620 },
//                       { year: "2024", price: 649 },
//                     ]}
//                   />
//                 </div>
//                 <div className="Chart-2">
//                   <div className="heading">MEDIAN PRICE</div>
//                   <CustomBarChart
//                     theme={theme}
//                     data={[
//                       { name: "MN", value: 1400 },
//                       { name: "BK", value: 800 },
//                       { name: "QN", value: 600 },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//         <Footer />
//       </div>
//       {/* PAGE 2 */}
//       <div className="report-container page-section">
//         <section className="report-section">
//           <h3 className="header-text">New York City</h3>
//           <div className="header-subtext__heading">NEW DEVELOPMENT</div>
//           <div className="subtext-grid">
//             <div className="header-inner-subtext__heading">
//               NEW DEVELOPMENT CONDO & CO-OP
//             </div>
//             <div>
//               <div>Date Range</div>
//               <div>YTD 2023 vs YTD 2024</div>
//             </div>
//           </div>
// 
//           <div className="semi-progress-container">
//             <div className="inner_heading_container">
//               <div>Contracts</div>
//               <CircularProgress value={"30%"} isPositive={true} />
//             </div>
//             <CustomSwitch
//               rows={[
//                 {
//                   firstValue: "Volume",
//                   middleValue: "",
//                   lastValue: "Units",
//                   header: true,
//                 },
//                 {
//                   firstValue: "10,895",
//                   middleValue: "YTD 2024",
//                   lastValue: "77 Days",
//                 },
//                 {
//                   firstValue: "12,183",
//                   middleValue: "YTD 2023",
//                   lastValue: "83 Days",
//                 },
//               ]}
//               hightlightedElement={1}
//             />
//             <div className="inner_heading_container">
//               <div>INVENTORY</div>
//               <div>
//                 <CircularProgress value={"37%"} isPositive={false} />
//               </div>
//             </div>
//           </div>
//           <div className="report-layout-outer-xl-switch-container">
//             <div className="content">
//               <p>
//                 Contract volume in 2024 retreated compared to 2023, reflecting a
//                 cooling post-COVID recovery market and the delayed effects of
//                 high mortgage rates.
//               </p>
// 
//               <p>
//                 Homes spent an average of six fewer days on the market in 2024,
//                 indicating that buyers are still quick to seize opportunities.
//               </p>
//             </div>
//             <div className="switch-xl-container">
//               <CustomSwitch
//                 rows={[
//                   {
//                     firstValue: "On the market",
//                     middleValue: "",
//                     lastValue: "Shadow",
//                     header: true,
//                   },
//                   { firstValue: "1,895", middleValue: "77 Days" },
//                 ]}
//                 hightlightedElement={0}
//                 style={{
//                   height: "6rem",
//                   widthInner: "13rem",
//                   outerWidth: "30rem",
//                   borderRadius: "70px",
//                   fontSize: "2em",
//                   fontWeight: 500,
//                 }}
//               />
//               <div>
//                 <span>81%</span> of new inventory is unlisted
//               </div>
//             </div>
//           </div>
//         </section>
//         <Divider theme={theme} />
//         <section className="report-section">
//           <div className="custom-charts horizontal-chart-section">
//             <div className="indicator-container">
//               <h3 className="heading">CLOSINGS</h3>
//               <Indicator
//                 price="$863K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Med Price"
//               />
//               <Indicator
//                 price="$663K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Price S/F"
//               />
//             </div>
//             <div className="chart_wrapper">
//               <div className="subtext">
//                 NYC has seen a steady rise in median prices and price per square
//                 foot overall, with Manhattan's sold prices nearly double those
//                 of Brooklyn and Queens
//               </div>
//               <div className="chart_inner">
//                 <div className="Chart-1">
//                   <div className="heading"> MEDIAN PRICE</div>
// 
//                   <HorizontalBarChart
//                     theme={theme}
//                     data={[
//                       { name: "BK", value: 400, barDisplayInnerValue: "$999K" },
//                       { name: "QN", value: 300, barDisplayInnerValue: "$698K" },
//                       {
//                         name: "MN",
//                         value: 200,
//                         barDisplayInnerValue: "$2.25M",
//                       },
//                     ]}
//                   />
//                 </div>
//                 <div className="Chart-2">
//                   <div className="heading">MEDIAN PRICE / SF</div>
//                   <CustomLineChart
//                     theme={theme}
//                     data={[
//                       { year: "2015", price: 417 },
//                       { year: "2016", price: 450 },
//                       { year: "2017", price: 480 },
//                       { year: "2018", price: 500 },
//                       { year: "2019", price: 520 },
//                       { year: "2020", price: 540 },
//                       { year: "2021", price: 600 },
//                       { year: "2024", price: 649 },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//         <Footer />
//       </div>
//       {/* PAGE 3 */}
//       <div className="report-container page-section">
//         <section className="report-section">
//           <h3 className="header-text">New York City</h3>
//           <div className="header-subtext__heading">Residential Sales</div>
//           <div className="subtext-grid">
//             <div className="header-inner-subtext__heading">
//               CONDO, CO-OP, SINGLE-FAMILY & MULTI-FAMILY
//             </div>
//             <div>
//               <div>Date Range</div>
//               <div>YTD 2023 vs YTD 2024</div>
//             </div>
//           </div>
// 
//           <div className="semi-progress-container">
//             <div className="inner_heading_container">
//               <div>Contracts</div>
// 
//               <CircularProgress value={"30%"} isPositive={true} />
//             </div>
//             <CustomSwitch
//               rows={[
//                 {
//                   firstValue: "Volume",
//                   middleValue: "",
//                   lastValue: "Days",
//                   header: true,
//                 },
//                 {
//                   firstValue: "10,895",
//                   middleValue: "YTD 2024",
//                   lastValue: "77 Days",
//                 },
//                 {
//                   firstValue: "12,183",
//                   middleValue: "YTD 2023",
//                   lastValue: "83 Days",
//                 },
//               ]}
//               hightlightedElement={1}
//             />
//             <div className="inner_heading_container">
//               <div>Days on Market</div>
//               <div>
//                 <CircularProgress value={"37%"} isPositive={false} />
//               </div>
//             </div>
//           </div>
//           <div className="report-layout-table-container">
//             {/* component for table */}
//             <CustomTable
//               headers={["PRICE RANGE", "YTD 2024", "YTD 2023", "% CHANGE"]}
//               rows={[
//                 ["UNDER $1M", "4,995", "6,040", "-17.3%"],
//                 ["$1M - $2M", "3,104", "3,312", "-6.3%"],
//                 ["$2M - $4M", "1,822", "1,780", "+2.4%"],
//                 ["$4M - $10M", "796", "865", "-8%"],
//                 ["OVER $10M", "178", "186", "-4.3%"],
//               ]}
//               theme={theme}
//               color={color}
//             />
//             <div className="table-side-container">
//               <p>
//                 Contract volume in 2024 retreated compared to 2023, reflecting a
//                 cooling post-COVID recovery market and the delayed effects of
//                 high mortgage rates.
//               </p>
// 
//               <p>
//                 Homes spent an average of six fewer days on the market in 2024,
//                 indicating that buyers are still quick to seize opportunities.
//               </p>
//             </div>
//           </div>
//         </section>
//         <Divider theme={theme} />
//         <section className="report-section">
//           <div className="custom-charts">
//             <div className="indicator-container">
//               <h3 className="heading">CLOSINGS</h3>
//               <Indicator
//                 price="$863K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Med Price"
//               />
//               <Indicator
//                 price="$663K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Price S/F"
//               />
//             </div>
//             <div className="chart_wrapper">
//               <div className="subtext">
//                 NYC has seen a steady rise in median prices and price per square
//                 foot overall, with Manhattan's sold prices nearly double those
//                 of Brooklyn and Queens
//               </div>
//               <div className="chart_inner">
//                 <div className="Chart-1">
//                   <div className="heading">MEDIAN PRICE / SF</div>
//                   <CustomLineChart
//                     theme={theme}
//                     data={[
//                       { year: "2015", price: 417 },
//                       { year: "2016", price: 450 },
//                       { year: "2017", price: 480 },
//                       { year: "2018", price: 500 },
//                       { year: "2019", price: 520 },
//                       { year: "2020", price: 540 },
//                       { year: "2021", price: 600 },
//                       { year: "2022", price: 610 },
//                       { year: "2023", price: 620 },
//                       { year: "2024", price: 649 },
//                     ]}
//                   />
//                 </div>
//                 <div className="Chart-2">
//                   <div className="heading">MEDIAN PRICE</div>
//                   <CustomBarChart
//                     theme={theme}
//                     data={[
//                       { name: "MN", value: 1400 },
//                       { name: "BK", value: 800 },
//                       { name: "QN", value: 600 },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//         <Footer />
//       </div>
//       {/* PAGE 4 */}
//       <div className="report-container page-section">
//         <section className="report-section">
//           <h3 className="header-text">SOUTH FLORIDA</h3>
//           <div className="header-subtext__heading">Residential Sales</div>
//           <div className="subtext-grid">
//             <div className="header-inner-subtext__heading">
//               MIAMI-DADE, PALM BEACH & BROWARD
//             </div>
//             <div>
//               <div>Date Range</div>
//               <div>YTD 2023 vs YTD 2024</div>
//             </div>
//           </div>
// 
//           <div className="semi-progress-container lastpage">
//             <div className="leftside_wrapper">
//               <div>
//                 <div className="inner_heading_container">
//                   <div>Contracts</div>
//                   <CircularProgress value={"30%"} isPositive={false} />
//                 </div>
//                 <CustomSwitch
//                   rows={[
//                     {
//                       firstValue: "Volume",
//                       middleValue: "",
//                       lastValue: "",
//                       header: true,
//                     },
//                     {
//                       firstValue: "58,442",
//                       middleValue: "YTD 2024",
//                       lastValue: "",
//                     },
//                     {
//                       firstValue: "65,756",
//                       middleValue: "YTD 2023",
//                       lastValue: "",
//                     },
//                   ]}
//                   hightlightedElement={1}
//                   style={{ outerWidth: "17rem", margin: "20px 0" }}
//                 />
//               </div>
//               <div className="subtext">
//                 Residential contracts fell by over 11% in 2024 compared to 2023,
//                 driven by high mortgage rates, rising insurance costs, and
//                 stricter HOA regulations. This continues a broader decline since
//                 the market peak in 2021.
//               </div>
//             </div>
//             <div className="horizontal-bar-last-chart">
//               <div className="heading"> YTD 2024</div>
//               <HorizontalBarChart
//                 theme={theme}
//                 data={[
//                   { name: "CONDO", value: 20054, barDisplayInnerValue: 20054},
//                   { name: "HOUSE", value: 33063, barDisplayInnerValue:33063 },
//                   
//                 ]}
//               />
//             </div>
//           </div>
//         </section>
//         <Divider theme={theme} />
//         <section className="report-section">
//           <div className="custom-charts indictor-last-page-section">
//             <div className="indicator-container">
//               <h3 className="heading">CLOSINGS</h3>
//               <Indicator
//                 price="$863K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Med Price"
//               />
//               <Indicator
//                 price="$663K"
//                 percentage={4.3}
//                 isPositive={true}
//                 name="Price S/F"
//               />
//             </div>
//             <div className="chart_wrapper">
//               <div className="subtext">
//                 NYC has seen a steady rise in median prices and price per square
//                 foot overall, with Manhattan's sold prices nearly double those
//                 of Brooklyn and Queens
//               </div>
//               <div className="chart_inner">
//                 <div className="Chart-1">
//                   <div className="heading">MEDIAN PRICE / SF</div>
//                   <CustomLineChart
//                     theme={theme}
//                     data={[
//                       { year: "2015", price: 417 },
//                       { year: "2016", price: 450 },
//                       { year: "2017", price: 480 },
//                       { year: "2018", price: 500 },
//                       { year: "2019", price: 520 },
//                       { year: "2020", price: 540 },
//                       { year: "2021", price: 600 },
//                       { year: "2022", price: 610 },
//                       { year: "2023", price: 620 },
//                       { year: "2024", price: 649 },
//                     ]}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>
//         </section>
//         <Footer />
//       </div>
//     </>
//   );
};

export default BlendedLayout;